export default __webpack_public_path__ + "static/media/icon-polygon.9cb0c764.svg";